import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router";
import { Card } from "reactstrap";
import ListComponent from "./ListComponent";
import { endpoint } from "views/pages/manage/common/constant";
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import FilterForm from './FilterForm';
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant"
import { FILTER__FORM_FIELDS_GLOBAL } from "./constants";
import { fetchAllPostPromisedData, updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import APopover from "views/pages/manage/common/a-popover";
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';


const VendorApprovalLogs = () => {
    const [loader, setLoader] = useState(false);
    const [rows, setRows] = useState([]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const configId = queryParams.get("configId");
    const eventType = queryParams.get("eventType");
    const [filterForm, setFilterForm] = useState({
        ...FILTER__FORM_FIELDS_GLOBAL,
    });
    const [filterCount, setFilterCount] = useState(
        getFilterCount({ ...filterForm }, ["searchByValue", "searchBy"])
    );


    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(50);

    const fetchLogs = async (pageNumber = 0, pageSize = currPageSize, reqObj, isFilterApplied = false) => {
        try {
            setLoader(true);

            let url = "";
            let resp = "";

            if (isFilterApplied) {
                resp = await fetchAllPostPromisedData(
                    `${endpoint?.vendorConfig?.logsFilter}?limit=${pageSize}&offset=${pageNumber}`,
                    { ...reqObj },
                    "post"
                );
            } else {
                url = `${endpoint?.vendorConfig?.logs}?limit=${pageSize}&offset=${pageNumber}&item_id=${configId}&eventType=${eventType}`;
                resp = await fetchAllPromisedData(url, true);
            }


            if (resp?.code === 200) {
                setCurrentPageSize(pageSize);
                setRows(resp?.data?.auditLogsList);
                setPaginationInfo({
                    currentPage: resp?.data?.currentPage,
                    totalPage: resp?.data?.totalPage,
                    totalRecords: resp?.data?.totalRecords,
                });
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    };

    const filterFormHandler = (key, value) => {
        setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }))
    }

    const applyFilterHandler = (reqObj = {}) => {
        reqObj = updateRequest(reqObj);

        const { event, dateFrom, dateTo } = reqObj;

        const newReqObj = {
            ...reqObj,
            eventType,
            itemId: configId,
            event: event,
            dateFrom,
            dateTo,
        };

        fetchLogs(0, 50, newReqObj, true);
    };

    const nextButtonHandler = (newPage, currPageSize) => {
        fetchLogs(newPage, currPageSize);
    };

    useEffect(() => {
        fetchLogs()
    }, [])

    return (
        <>
            <Card className="mx-2">
                <div className="d-flex justify-content-between my-3 mx-2">
                    <div className="d-flex justify-content-between">
                        <IconButtonWrapper onClick={() => window.close()}>
                            <BackArrow />
                        </IconButtonWrapper>
                        <h4 style={{ marginTop: "11%" }} className="color-black">Logs</h4>
                    </div>
                    <div>
                        <APopover
                            buttonComponent={(onClick, styles) => (
                                <AButton
                                    className="tiny-semi-bold color-dark"
                                    onClick={onClick}
                                    updatedStyle={{
                                        minWidth: "61px",
                                        ...(filterCount > 0
                                            ? {
                                                border: "1px solid #00B0F5",
                                                color: "#00B0F5",
                                            }
                                            : styles),
                                    }}
                                >
                                    Filters {filterCount > 0 && <>( {filterCount} )</>}
                                </AButton>
                            )}
                            menuComponent={(closePopup) => (
                                <FilterForm
                                    closePopup={closePopup}
                                    filterForm={filterForm}
                                    filterCount={filterCount}
                                    setFilterCount={setFilterCount}
                                    setFilterForm={setFilterForm}
                                    applyFilterHandler={applyFilterHandler}
                                    filterFormHandler={filterFormHandler}
                                />
                            )}
                        />
                    </div>
                </div>

                <ListComponent
                    loader={loader}
                    currentPage={paginationInfo?.currentPage}
                    currPageSize={currPageSize}
                    rows={rows}
                    nextButtonHandler={nextButtonHandler}
                    rowCount={paginationInfo.totalRecords}
                />
            </Card>
        </>
    )
}

export default VendorApprovalLogs